const LANGUAGE_PREFERENCES = {
  ENGLISH: 'english',
  HINDI: 'hindi',
};

export default LANGUAGE_PREFERENCES;
